import React from "react";
import { Route, Routes } from "react-router-dom";
import Token from '../components/Token';
import FAQ from '../components/FAQ';
import Terms from '../components/TNC';
import Shayatri from '../components/Sahayatri';
import Roaming from '../components/Roaming';
import ClaimForm from '../components/ClaimForm'
import MobileInsure from "../components/MobileInsure";
import DataSangaiBeemaBiz200 from "../components/DataSangaiBeemaBiz200";
import NcellSadhaiOn from "../components/NcellSadhaiOn";
import DataSangaiPhoneBeema from "../components/DataSangaiPhoneBeema";
import DataSangaiBeemaPlus from "../components/DataSangaiBeemaPlus";
import NcellAppPage from "../components/NcellAppPage";
import NcellSmartPhoneOffer from "../components/NcellSmartPhoneOffer";
import RoamingSadhaiOn from "../components/RoamingSadhaiOn";
import DataSangaiBeemaRetailer499 from "../components/DataSangaiBeemaRetailer499";
import DataSangaiBeemaRetailer999 from "../components/DataSangaiBeemaRetailer999";

function MainRoute() {
  return (
    <Routes>
      <Route path="/" element={<Token/>}/>
      <Route path="/:token" element={<Token/>} exact="true"/>
      <Route path="/claims-form" element={<ClaimForm/>} exact="true" />
      <Route path="/faq" element={<FAQ/>}  exact="true" />
      <Route path="/terms-and-conditions" element={<Terms />}  exact="true" />
      <Route path="/sahayatri" element={<Shayatri />} exact="true" />
      <Route path="/roaming" element={<Roaming />} exact="true" />
      <Route path="/mobileinsurance" element={<MobileInsure />} exact="true" />
      <Route path="/datasangaibeemabiz200" element={<DataSangaiBeemaBiz200 />} exact="true" />
      <Route path="/ncellsadhaion" element={<NcellSadhaiOn />} exact="true" />
      <Route path="/roamingsadhainon" element={<RoamingSadhaiOn />} exact="true" />
      <Route path="/datasangaiphonebeema" element={<DataSangaiPhoneBeema />} exact="true" />
      <Route path="/datasangaibeemaplus" element={<DataSangaiBeemaPlus />} exact="true" />
      <Route path="/ncellapppage" element={<NcellAppPage />} exact="true" />
      <Route path="/ncellsmartphoneoffer" element={<NcellSmartPhoneOffer />} exact="true" />
      <Route path="/datasangaibeemaretailer499" element={<DataSangaiBeemaRetailer499 />} exact="true" />
      <Route path="/datasangaibeemaretailer999" element={<DataSangaiBeemaRetailer999 />} exact="true" />
    </Routes>
  );
}

export default MainRoute;
